import styles from './index.module.scss'
const Footer = () => {
    return (
        <div>
            <div className={styles.footer}>
                <ul>
                    <div className={styles.title}>McCharts</div>
                    <li>
                        <a href="/Introduction"  rel="noopener noreferrer">McCharts是什么？</a>
                    </li>
                    <li>
                        <a href="/Introduction"  rel="noopener noreferrer">为什么选择McCharts</a>
                    </li>
                    {/*<li>*/}
                    {/*    <a>更新日志</a>*/}
                    {/*</li>*/}
                </ul>
                <ul>
                    <div className={styles.title}>资源</div>
                    <li>
                        <a target="_blank"  href="/McLineChart" rel="noopener noreferrer">文档</a>
                    </li>

                    <li>
                        <a target="_blank" href="https://gitee.com/cyaofeng_admin/mc-charts" rel="noopener noreferrer">Gitee</a>
                    </li>
                    {/*<li>*/}
                    {/*    <a target="_blank" href="https://gitee.com/cyaofeng_admin/mc-charts" rel="noopener noreferrer">Github</a>*/}
                    {/*</li>*/}
                    <li>
                        <a target="_blank" href="https://ohpm.openharmony.cn/#/cn/detail/@mcui%2Fmccharts" rel="noopener noreferrer">OpenHarmony</a>
                    </li>
                    <li>
                        <a target="_blank">隐私政策</a>
                    </li>
                </ul>
                <ul>
                    <div className={styles.title}>帮助</div>
                    <li>
                        <a target="_blank" href="https://docs.qq.com/sheet/DYkdNQ212dW5NYVVz?tab=ss_n1t7by&from=form&viewId=fv1" rel="noopener noreferrer">问题收集表</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://gitee.com/cyaofeng_admin/mc-charts/issues" rel="noopener noreferrer">Gitee 问题</a>
                    </li>
                </ul>
            </div>
            <footer className={styles.footerIcp}>
                <p>备案号：<a href="http://beian.miit.gov.cn" target="_blank">粤ICP备2024324957号-1</a></p>
                <p>主办单位：深圳莓创技术科技有限公司</p>
                <p>公司地址：深圳市南山区粤海街道高新区社区高新南九道45号西北工业大学三航科技大厦 1437号</p>
                <p>邮箱：meichuangit@foxmail.com</p>
            </footer>
        </div>

    )
}

export default Footer
